export default __webpack_public_path__ + "static/1-68c618c3052413a43c1fc9c6a63691c0.png";